import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Columbarium", href: "#columbarium" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-white/85 border-b border-[#0C2340]/10">
      <nav className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <a href="#home" data-testid="nav-brand-logo" className="flex items-center gap-2.5">
          <img src="/images/logo.png" alt="Davao Memorial Park logo" className="w-9 h-9 object-contain" />
          <span className="font-display text-xl font-semibold text-[#0C2340] leading-none">
            Davao Memorial Park
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[#0C2340]/80 hover:text-[#C59B27] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#inquire"
            data-testid="nav-inquire-btn"
            className="text-sm font-semibold bg-[#C59B27] hover:bg-[#b08b22] text-[#0C2340] px-5 py-2.5 rounded-full transition-colors"
          >
            Inquire Now
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="md:hidden text-[#0C2340]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-t border-[#0C2340]/10 px-4 py-4 flex flex-col gap-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="text-sm font-medium text-[#0C2340] py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#inquire"
            data-testid="nav-mobile-inquire-btn"
            onClick={() => setOpen(false)}
            className="text-sm font-semibold bg-[#C59B27] text-[#0C2340] px-5 py-2.5 rounded-full text-center"
          >
            Inquire Now
          </a>
        </div>
      )}
    </header>
  );
}
